import type { CasOrCategory } from '../../types/db.ts';

export const emissionsStandardPollutants: { key: CasOrCategory; label: string }[] = [
  { key: 'PM' as CasOrCategory, label: 'PM (Total)' },
  { key: 'PM Filterable' as CasOrCategory, label: 'PM Filterable' },
  { key: 'PM Condensable' as CasOrCategory, label: 'PM Condensable' },
  { key: 'PM10' as CasOrCategory, label: 'PM10 (Total)' },
  { key: 'PM10 Filterable' as CasOrCategory, label: 'PM10 Filterable' },
  { key: 'PM2.5' as CasOrCategory, label: 'PM2.5 (Total)' },
  { key: 'PM2.5 Filterable' as CasOrCategory, label: 'PM2.5 Filterable' },
  { key: 'NOx' as CasOrCategory, label: 'NOx' },
  { key: 'SOx' as CasOrCategory, label: 'SOx' },
  { key: '630-08-0' as CasOrCategory, label: 'CO' },
  { key: 'VOC' as CasOrCategory, label: 'VOC' },
  { key: '7439-92-1' as CasOrCategory, label: 'Lead' },
  { key: 'CO2e' as CasOrCategory, label: 'CO2e' },
  { key: '124-38-9' as CasOrCategory, label: 'CO2' },
  { key: '10024-97-2' as CasOrCategory, label: 'N2O' },
  { key: '74-82-8' as CasOrCategory, label: 'Methane' },
  { key: 'F' as CasOrCategory, label: 'Fluorides' },
];
